import { ReactComponent as IconLogo } from './logo.svg';

export const Logo=()=>{
    return(
        <IconLogo  aria-label={'icon-logo'} id='logo'/>
    )
}